import React from 'react';
import {Button, PopoverBody, UncontrolledPopover} from 'reactstrap';
import apiBarcode from '../../services/api/apiBarcode';
import classNames from 'classnames';

class ListItemsNote extends React.Component {
    state = {
        note: '',
        isLoadingNote: false
    };

    componentDidMount() {
        this._loadStateFromProps();
    }

    _loadStateFromProps = () => {
        const {note} = this.props;
        this.setState({note});
    };

    _handleChangeInput = (e) => {
        const {target: {name, value}} = e;
        this.setState({[name]: value});
    };

    _renderIconNote = () => {
        if (this.state.isLoadingNote)
            return <i className='icon-spinner2 spinner ml-2'/>;
        return <i className='icon-quill4 ml-2'/>;
    };

    _handleSaveNote = async () => {
        this.setState({isLoadingNote: true});

        try {
            const {itemId} = this.props;
            const {note} = this.state;
            const resUpdated = await apiBarcode.updateBarcode(itemId, {note});

            const {success, message} = resUpdated.data;
            if (!success) throw new Error(message);
        } catch (e) {
            alert(e.message);
        }

        this.setState({isLoadingNote: false});
    };

    render() {
        const {id} = this.props;
        const {note} = this.state;

        const classNameIcon = classNames({
            'icon-quill4': true,
            'text-danger': !!note,
            'text-success': !note
        });

        return (
            <div className='ListItemsNote'>
                <i className={classNameIcon} id={id}/>
                <UncontrolledPopover placement='bottom' trigger='legacy' target={id}>
                    <PopoverBody>
                        <textarea className='form-control' name='note' value={note} onChange={this._handleChangeInput}/>
                        <div className='text-right mt-2'>
                            <Button color='primary' onClick={this._handleSaveNote}>
                                Save Note
                                {this._renderIconNote()}
                            </Button>
                        </div>
                    </PopoverBody>
                </UncontrolledPopover>
            </div>
        );
    }
}

export default ListItemsNote;
